<template>
    <router-link v-if="checkIfVisible()"
                 :to="{ name: route, params: {id: itemId}, query: query }"
                 class="pb-2"
                 :title="$t('edytuj')"
                 tag="a">
        <span class="icon icon-edit"></span>
    </router-link>
</template>

<script>
import { checkUserPermissions } from '@/config/AppConfig'

export default {
  props: ['route', 'itemId', 'query', 'disabled', 'permissionParam'],
  methods: {
    checkIfVisible () {
      if (this.disabled === true) {
        return false
      }
      if (this.permissionParam !== undefined && this.permissionParam !== null) {
        return checkUserPermissions(this.permissionParam)
      }
      return true
    }
  }
}
</script>
